import {
  DraggableTree
} from 'vue-draggable-nested-tree'
export default {
  name: 'menu',
  components: { Tree: DraggableTree },
  props: [],
  data () {
    return {
      data: [],
      data2: [],
      datadf: [],
      button_edit: true,
      group: {}
    }
  },
  computed: {
  },
  mounted () {
  
    Promise.all([
      this.$store.dispatch('Menu/getMenuOfGroup', {group_id: this.$route.params.group_id}),
      import('../../../_nav'),
      this.$store.dispatch('Group/showGroup', {group: {id: this.$route.params.group_id}})
    ]).then(res => {
      this.data2 = res[0]
      this.data = []
      this.datadf = res[1].default.items
      for(var i=0; i < this.datadf.length; i++){
        var item = this.datadf[i]
        var exists = this.data2.filter(element => element.name == item.name)
        if(exists.length == 0){
          this.data.push(item);
        }
      }
      this.group = res[2]
      
    }).catch(errors => {
      
    })
  },
  methods: {
    edit () {
      this.button_edit = false
      // this.data2 = []

    },
    xyz (element) {
      var x = {}
      x.name = element.name ? element.name : ''
      x.url = element.url ? element.url : ''
      x.icon = element.icon ? element.icon : ''
      // x.variant = element.variant ? element.variant : ''
      // x.class = element.class ? element.class : ''
      x.title = element.title ? element.title : false
      x.children = []
      if (element.children.length) {
        element.children.forEach(child => {
          x.children.push(this.xyz(child))
        })
      }
      return x
    },
    zyx (array) {
      var tam = []
      array.forEach(element => {
        tam.push(this.xyz(element))
      })
      return tam
    },
    save () {
      var data = this.zyx(this.data2)
    
      this.$store.dispatch('Menu/updateMenu', {group: this.group, data}).then(res => {
        
        this.$router.push('/group')
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {
        
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/group/menu/menu.js